import React from "react";
import ReportsAdminShareCom from "./ReportsAdminShareCom";

const options = [
  { value: "total_ex_by_location", title: "Total Exp. By Location", code: null },
  { value: "ex_by_location_new", title: "Personnel Exp. by Location", code: "Personnel" },
  { value: "ex_by_location", title: "Debt Service By Location", code: "3%" },
  { value: "ex_by_location_new", title: "Other NDR Exp. By Location", code: "OverHead" },
  { value: "ex_by_location_new", title: "Capital Exp. by Location", code: "Capital" },
];

export default function ExpByLocation() {
  return (
    <ReportsAdminShareCom
      defaultType="total_ex_by_location"
      defaultTitle="Total Exp. By Location"
      options={options}
      route="reports"
      sheetName="Expenditure by Location"
    />
  );
}
